'use client'

import ErrorHandler, {
  type ErrorHandlerProps,
} from '#lib/client/components/common/error-handler.tsx'

export default function Error(props: ErrorHandlerProps) {
  return <ErrorHandler {...props} />
}
